import { render, staticRenderFns } from "./assessSummary.vue?vue&type=template&id=e1fff652&scoped=true"
import script from "./assessSummary.vue?vue&type=script&lang=js"
export * from "./assessSummary.vue?vue&type=script&lang=js"
import style0 from "./assessSummary.vue?vue&type=style&index=0&id=e1fff652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fff652",
  null
  
)

export default component.exports